import {
	GQLProductFlatImageFragment,
	GQLProductFragment,
	GQLProductSideAvailableDecorationType,
	GQLProductSideFragment,
	GQLProductSideSideType,
	GQLStoreFragment,
} from '@theprintbar/graphql';
import { getSortedDecorationTypes } from './decorations';

export const orderedProductSides: GQLProductSideSideType[] = [
	GQLProductSideSideType.Front,
	GQLProductSideSideType.Back,
	GQLProductSideSideType.Left,
	GQLProductSideSideType.Right,
	GQLProductSideSideType.Label,
];

export function getSortedSides(product: Pick<GQLProductFragment, 'sides'>) {
	return product.sides.sort((a, b) => orderedProductSides.indexOf(a.side) - orderedProductSides.indexOf(b.side)) || [];
}

export function getFlatLaysSortedBySide(flatLays: GQLProductFlatImageFragment[]) {
	return flatLays.sort((a, b) => {
		if (!a.side || !b.side) return 0;
		return orderedProductSides.indexOf(a.side.side) - orderedProductSides.indexOf(b.side.side);
	});
}

export function isSleeve(side: GQLProductSideSideType) {
	return side === GQLProductSideSideType.Left || side === GQLProductSideSideType.Right;
}

export function isLabel(side: GQLProductSideSideType) {
	return side === GQLProductSideSideType.Label;
}

interface GetAvailableSideDecorationProps {
	side: GQLProductSideFragment;
	sameday?: boolean;
}

export function getAvailableSideDecoration({ side, sameday }: GetAvailableSideDecorationProps) {
	const sortedDecs = getSortedDecorationTypes(side);

	if (sameday) {
		return sortedDecs.filter(d => d === GQLProductSideAvailableDecorationType.Dtg)[0];
	}

	return sortedDecs[0];
}
